import { render, staticRenderFns } from "./Day02.vue?vue&type=template&id=5d612d2e"
import script from "./Day02.vue?vue&type=script&lang=js"
export * from "./Day02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports